/* eslint-disable import/no-anonymous-default-export */
import { carsSaga } from './cars';
import { optionsSaga } from './options';
import { errorSaga } from './error';

export default [carsSaga, optionsSaga, errorSaga];



// WEBPACK FOOTER //
// ./src/redux/sagas/index.js